
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getPaginatedDeployments",
      resolverType: "query",
      routePath: "/getPaginatedDeployments",
      httpMethod: "POST",
    });
  